import { Component, ViewChild } from '@angular/core';
import { CommonModule, Location  } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';

// PrimeNG
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';

// Spinner
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from '../../services/company.service';
import { W9StateService } from '../../../common/services/W9StateService';
import { Messages } from '../../../common/constants/messages';

@Component({
  selector: 'app-replace-w9',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FileUploadModule,
    DialogModule,
    NgxSpinnerModule
  ],
  templateUrl: './replace-w9.component.html',
  styleUrls: ['./replace-w9.component.css']
})
export class ReplaceW9Component {

  modalDlg = false;
  dialogSummary = '';
  dialogMsg = '';
  replaceW9Form: FormGroup;
  showReplaceConfirm = false;
  @ViewChild('fileUploadRef') fileUploadRef!: FileUpload;
  companyId: string = '';
  isFileValid = false;
  fileSizeError = false;
  constructor(
    private fb: FormBuilder,
    private companyService: CompanyService,
    private ngx: NgxSpinnerService,
    private router: Router,
    private w9State: W9StateService,
    private location: Location
  ) {
    this.replaceW9Form = this.fb.group({
      w9File: [null, Validators.required]
    });
  }


  ngOnInit(): void {
    this.companyId = this.w9State.getCompanyId();
  }

  triggerFileSelect() {
    this.fileUploadRef.choose();
  }

 onFileSelect(event: any) {
  this.fileSizeError = false;
  this.isFileValid = false;
  const allowedExtensions = ['pdf', 'jpg', 'jpeg'];

  const file = event.files?.[0];
  const extension = file.name.split('.').pop()?.toLowerCase();

  if (!file) {
    return;
  }

  const maxFileSize = 5 * 1024 * 1024; // 5 MB

  // Explicitly validate file size
  if (file.size > maxFileSize || 
      !extension || !allowedExtensions.includes(extension)) {
    this.fileSizeError = true;
    this.isFileValid = false;

    this.replaceW9Form.patchValue({
      w9File: null
    });

    this.replaceW9Form.get('w9File')?.setErrors({
      fileSize: true
    });

    return;
  }

  // Valid file
  this.replaceW9Form.patchValue({
    w9File: file
  });

  this.replaceW9Form.get('w9File')?.setErrors(null);

  this.isFileValid = true;
}

onFileError(event: any) {
  this.fileSizeError = true;
  this.isFileValid = false;

  this.replaceW9Form.patchValue({
    w9File: null
  });

  this.replaceW9Form.get('w9File')?.setErrors({
    fileSize: true
  });
}

 onFileRemove(event: any) {
  this.fileSizeError = false;
  this.isFileValid = false;

  this.replaceW9Form.patchValue({
    w9File: null
  });

  this.replaceW9Form.get('w9File')?.setErrors({
    required: true
  });
}

  confirmReplace() {
  if (
    !this.isFileValid ||
    this.fileSizeError ||
    this.replaceW9Form.invalid
  ) {
    this.replaceW9Form.markAllAsTouched();
    return;
  }

  this.showReplaceConfirm = true;
}

  submitReplaceW9() {
    this.showReplaceConfirm = false;

    const file = this.replaceW9Form.get('w9File')?.value;

    if (!file || !this.companyId) return;

    this.ngx.show();

    this.companyService.uploadW9(this.companyId, file).subscribe({
      next: () => {
        this.ngx.hide();
         // Redirect back to table
         this.location.back();

      // optional cleanup
      sessionStorage.removeItem('replaceW9CompanyId');
      },
      error:(err) => {
        this.ngx.hide();
        this.dialogSummary = Messages.ErrorTitle;
        this.dialogMsg = Messages.SaveFailedMessage;
        this.modalDlg = true;
      }
    });
  }

  cancel() {
    sessionStorage.removeItem('replaceW9CompanyId');
    this.location.back();
  }
  okClicked() {
    this.modalDlg = false;   
  } 
}